/* eslint-disable @typescript-eslint/naming-convention */
import {
    CartItem,
    CartItemWithUUID,
    CrossSellTabType,
    ICrossSellHeader,
    ReviewedCartApiResponse,
    SubsItem,
} from "@swiggy-private/cart-types";
import { CART_STATUS_CODES } from "@swiggy-private/cart-ui";
import { ReactNode } from "react";

export type ApiMenuSubsItem = Pick<SubsItem, "plan_id" | "quantity">;
/* eslint-disable @typescript-eslint/naming-convention */

export enum INTERNAL_CART_SOURCE {
    DEFAULT_FOOD = "DEFAULT_FOOD",
    GIFTING = "GIFTING",
    MRO_FOOD = "MRO_FOOD",
    QUICK_CHECKOUT = "QUICK_CHECKOUT",
}

export interface ApiCartCtaMeta {
    collection_id: string;
    restaurant_id: string;
    city_id: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export enum AddCakeMessageWidgetType {
    ADD = "Add message on cake",
    EDIT = "Edit message on cake",
}

export interface ReviewedCart {
    data: ReviewedCartApiResponse | null;
    statusCode: CART_STATUS_CODES;
    statusMessage?: string;
    ctaText?: string;
    ctaAction?: CtaAction;
    ctaIcon?: string | null;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    cta_meta?: ApiCartCtaMeta;
    titleMessage?: string;
    stayOnCartScreen?: boolean;
    sid?: string;
}

export enum CtaAction {
    CLEAR_CART = "clearCart",
    GO_TO_HOME = "goToHome",
    GO_TO_SIMILAR_RESTAURANT = "goToSimilarRestaurants",
    GO_TO_LOGIN = "goToLogin",
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface ApiCartItemAddons {
    choice_id: string;
    group_id: string;
    name: string;
    price: number;
}
/* eslint-enable @typescript-eslint/naming-convention */

/* eslint-disable @typescript-eslint/naming-convention */
export interface ApiCartItemVariants {
    variation_id: number;
    external_choice_id: string;
    group_id: number;
    name: string;
    price: number;
}
/* eslint-enable @typescript-eslint/naming-convention */

export enum OFOWidgetPosition {
    TOP,
    BOTTOM,
}

export interface OFOWidgetDetails {
    titleOFOWidget?: string;
    subTitleOFOWidget?: string;
    actionTextOFOWidget?: string;
    showGiftIcon?: boolean;
    showTitleAboveWidget?: boolean;
    widgetPosition?: OFOWidgetPosition;
}
/* eslint-disable @typescript-eslint/naming-convention */

export interface RawOrderItem {
    order_items: CartItem[];
    restaurant_id: string;
    restaurant_name: string;
    restaurant_cover_image: string;
    delivery_address: {
        id: string;
    };
    selected_sla_option: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface GetSingleOrderApiData {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    customer_care_number: string;
    orders: RawOrderItem[];
}
export interface CommonUIWrapperProps {
    content: ReactNode;
    containerCSSClass?: string;
    containerId?: string;
    coreLayoutCustomClassName?: string;
    header: ReactNode;
    headerCSSClass?: string;
    onBack?: VoidFunction;
    isPageScrolled?: boolean;
    showAddressWidgetTop?: boolean;
    cartIncognitoModeXp?: boolean;
    isIncognitoCart?: boolean;
    isCartContentHeader?: boolean;
    isSavingsBannerExist?: boolean;
    isAddressSelected?: boolean;
    isPopCart?: boolean;
    isIrctcCart?: boolean;
    isJioHotstarFlow?: boolean;
    isCartError?: boolean;
    useHeaderV2?: boolean;
}

export interface CrossSellM2Suggestions {
    suggestions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        cross_sell_suggestions?: CartItemWithUUID[];
        type?: CrossSellTabType;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        display_name?: string;
    }[];
    allCrossSellSuggestionsAdded: boolean;
    allCrossSellSuggestionsAddedText?: string;
    defaultTabSelected: CrossSellTabType | null;
    crossSellHeader: ICrossSellHeader;
}
